import {MouseEventHandler} from 'react'

interface ButtonProps {
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined
}

export default function BackButton({onClick}: ButtonProps) {
  return (
    <button
      className="back-button border bg-gray-200 rounded-md p-2 cursor-pointer"
      onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        className="w-6 h-6 text-gray-500">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.75 19.5L8.25 12l7.5-7.5"
        />
      </svg>
    </button>
  )
}
